var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('section-main'),_c('section-events'),_c('section-documents'),_c('section-institutions'),_c('section-teachers'),_c('section-reviews'),_c('section-promo'),_c('section-about-us'),_c('section-f-a-q'),_c('section-map')],1)}
var staticRenderFns = []

export { render, staticRenderFns }